/*!
 * midiSpec.js — a MIDI message as written: note60  cc64  pc3  (@channel)
 * © 2026 Rob Canning — GPLv3
 *
 * Shared by the score's pedal map (system/midiInput.js) and the animation
 * cues' trig:midi, midi:<spec> (cues/animShared.js).
 */

/** "note60" | "cc64@1" | "pc3" -> { kind, num, ch|null }, or null. */
export function parseMidiSpec(v) {
    if (v == null) return null;
    const s = String(v).trim().toLowerCase().replace(/['"]/g, '');
    const m = s.match(/^(note|n|cc|c|pc|p)\s*:?\s*(\d{1,3})(?:\s*@\s*(\d{1,2}))?$/);
    if (!m) return null;
    const kind = m[1][0] === 'n' ? 'note' : m[1][0] === 'c' ? 'cc' : 'pc';
    const num = Number(m[2]); if (num > 127) return null;
    const ch = m[3] != null ? Number(m[3]) : null;
    if (ch != null && (ch < 1 || ch > 16)) return null;
    return { kind, num, ch };
}

export function specToString(spec) {
    return `${spec.kind}${spec.num}${spec.ch != null ? '@' + spec.ch : ''}`;
}
